import React from "react";
import { useState, useRef, useEffect } from 'react'
import axios from 'axios';

const Modal = (props) => {
    const patientWordField = {
      width: "87%"
    } as React.CSSProperties;

    const searchPatientButton = {
      width: "10%",
      marginLeft: "3%"
    } as React.CSSProperties;

    const goocoCheckBox = {
      textAlign: "left",
      marginLeft: "2%",
      marginTop: "2%"
    } as React.CSSProperties;

    const [ searchWord, setSearchWord ] = useState(props.patientBirthday);
    const [ isGooco, setIsGooco] = useState(true);
    const [ patientList, setPatientList ] = useState([]);
    const [ selectedMPatient, setSelectedMPatient ] = useState(0);
    const renderFlgRef = useRef(false);
    const buttonEl = useRef(null);
    const searchWordEl = useRef(null);

    useEffect(() => {
      setSelectedMPatient(0);
      setSearchWord(props.patientBirthday);
      searchWordEl.current.value = props.patientBirthday;
    },[props])

    useEffect(() => {
      if (renderFlgRef.current) {
        searchPatients(props.patientBirthday, 0, isGooco);
      } else {
        renderFlgRef.current = true;
      }
    },[props.patientBirthday])

    useEffect(() => {
      var elem = document.getElementsByClassName('select-patient');
      if(elem.length > 0) {
        elem[0].classList.remove('select-patient');
      }
      setSelectedMPatient(0);
    }, [searchWord])

    useEffect(() => {
        var elem = document.getElementsByClassName('select-patient');
        if(elem.length > 0) {
          elem[0].classList.remove('select-patient');
        }
        setSelectedMPatient(0);
    }, [isGooco])

    function searchPatients(searchWord, limitFlg, isGooco){
      axios.get(
        '/api/internal/patients/get_patients', {
          params: {
            search_word: searchWord,
            limitFlg: limitFlg,
            isGooco: isGooco
          }
        })
        .then(function (response) {
          const m_patients = response.data.m_patients

          if (m_patients.length == 0) {
            setPatientList([]);
          } else {
            setPatientList(m_patients);
          }
        })
        .catch(error => {
          alert(error.response.data.message);
        });
    }

    function changeGooco(isGooco){
      if(isGooco === true){
        setIsGooco(false)
      }else{
        setIsGooco(true)
      }
    }

    function sortIndexProps(dInterviewDetails) {
      const status0 = dInterviewDetails.filter(dInterviewDetail => {return dInterviewDetail.status === 0}); //送信済み
      const status1 = dInterviewDetails.filter(dInterviewDetail => {return dInterviewDetail.status === 1}); //入力済み
      const status2 = dInterviewDetails.filter(dInterviewDetail => {return dInterviewDetail.status === 2}); //入力中
      const unsortedStatus3 = dInterviewDetails.filter(dInterviewDetail => {return dInterviewDetail.status === 3}); //連携待ち
      // 連携待ちのみ入力時間で再度ソートし直す
      const status3 = unsortedStatus3.sort(function(a, b) { return (a.start_at < b.start_at ? 1 : -1) });
      const status4 = dInterviewDetails.filter(dInterviewDetail => {return dInterviewDetail.status === 4}); //連携済み
      const sortedDInterviewDetails = status2.concat(status1, status3, status4, status0);
      return sortedDInterviewDetails;
    }

    function getFilteredDInterviewDetails(status, flg) {
      if (flg === true) {
        const newIndexProps = props.defaultIndexProps.filter(dInterviewDetail => dInterviewDetail.status === status);
        return newIndexProps;
      } else {
        const newIndexProps = props.defaultIndexProps.filter(dInterviewDetail => dInterviewDetail.status === status && dInterviewDetail.display_flg === 1);
        return newIndexProps;
      }
    }

    function link(d_interview_detail_id, m_patient_id) {
      if (selectedMPatient == 0) {
        alert("患者を選択していない状態では紐づけできません。")
        return
      }

      axios.patch(
        '/api/internal/patients/link', {
            d_interview_detail_id: d_interview_detail_id,
            m_patient_id: m_patient_id
        })
        .then(function (response) {
          const d_interview_detail = response.data.d_interview_detail;
          const m_patient = response.data.m_patient;
          const dInterviewDetailId = d_interview_detail.id;
          // null + null = 0になる為、表示ミスが起きない様に以下の様に条件分岐
          const address1 = m_patient.address1 === null ? "" : m_patient.address1;
          const address2 = m_patient.address2 === null ? "" : m_patient.address2;
          const address3 = m_patient.address3 === null ? "" : m_patient.address3;
          const full_address = address1 + address2 + address3;

          // モーダルを消す
          buttonEl.current.click();
          // 参照用のステートを更新
          const i = props.defaultIndexProps.findIndex(({id}) => id === dInterviewDetailId);
          props.defaultIndexProps[i].status = 3;
          props.defaultIndexProps[i].kanzyano = m_patient.consultation_ticket_no;
          props.defaultIndexProps[i].m_patient_id = m_patient.id;
          props.defaultIndexProps[i].patient_name = m_patient.name;
          props.defaultIndexProps[i].mobile_phone_number = m_patient.mobile_phone;
          props.defaultIndexProps[i].address = full_address;
          props.updateIndexProps(props.defaultIndexProps);
        })
        .catch(error => {
          console.log(error.response)
        });
    }

    var calcAge = function(birthdayStr){
      if(isNaN(birthdayStr)||birthdayStr.length !== 8){
        return -1;
      }
      var d = new Date();
      var dStr = ''+d.getFullYear()+('0'+(d.getMonth()+1)).slice(-2)+('0'+d.getDate()).slice(-2);
      return Math.floor((parseInt(dStr)-parseInt(birthdayStr))/10000);
    };

    return (
      <>
        <div className="modal fade" data-backdrop="static" id="messageModal">
          <div className="modal-dialog modal-width">
            <div className="modal-content">
              <div className="modal-header bg-success">
                <button type="button" className="close" ref={buttonEl} data-dismiss="modal">
                  <span aria-hidden="true">&#215;</span><span className="sr-only">閉じる</span>
                </button>
                <h4 className="modal-title text-center modal-title-align">
                  患者情報の紐づけを行います
                </h4>
              </div> {/* /modal-header */}

              <div className="modal-body interview-status-modal-body">
                <form className="form-horizontal">
                  <div className="text-center modal-form-height">
                    <div className="form-group" id="patient_word">
                      <label className="pull-left">検索したい内容を入力してください(氏名・カナ氏名・携帯電話番号・患者番号・生年月日)</label>
                      <div className="form-inline text-left modal-form-inline">
                        <input
                        type="text"
                        className="form-control patient_field"
                        placeholder="検索したい内容を入力してください"
                        style={patientWordField}
                        onChange={(e) => setSearchWord(e.target.value)}
                        ref={searchWordEl} />
                        <input
                        type="button"
                        className="form-control patient_field btn-primary"
                        style={searchPatientButton}
                        onClick={() => searchPatients(searchWord, 1, isGooco)}
                        value="検索" />
                      </div>
                      <div style={goocoCheckBox}>
                        <label className="status-filter-label"><input type="checkbox" checked={isGooco} onChange={() => changeGooco(isGooco)}/>GooCo連携済み患者</label>
                      </div>
                    </div> {/* /form-group */}

                    <div className="modal-patient-table-wrapper" id="patient_name_list">
                      <table className="table table-bordered" id="notice_table">
                        <thead>
                          <tr className="success">
                            <th scope="col" className="text-center va_middle" style={{width: "20%"}}>患者番号</th>
                            <th scope="col" className="text-center va_middle" style={{width: "30%"}}>患者名(性別)</th>
                            <th scope="col" className="text-center va_middle" style={{width: "5%"}}>連携</th>
                            <th scope="col" className="text-center va_middle" style={{width: "28%"}}>生年月日</th>
                            <th scope="col" className="text-center va_middle" style={{width: "28%"}}>携帯電話番号</th>
                          </tr>
                        </thead>
                        <tbody id="patient-body">
                        {
                          patientList.map((patient) => {
                            return (
                              <>
                                <tr key={patient.id}
                                    id={`mpi${patient.id}`}
                                    className={selectedMPatient == patient.id ? "select-patient" : ""}
                                    onClick={() => setSelectedMPatient(patient.id)}>
                                  <td scope="col" className="text-center">{patient.consultation_ticket_no}</td>
                                  <td scope="col" className="text-center">
                                    {patient.name}
                                    <span> (</span>
                                    {(() => {
                                        if (patient.sex === 1) {
                                            return "男";
                                        } else if (patient.sex === 2) {
                                            return "女";
                                        } else {
                                          return "";
                                        }
                                    })()}
                                    <span>)</span>
                                  </td>
                                  <td scope="col" className="text-center">
                                  {(() => {
                                        if(patient.gooco_no === null){
                                          return "";
                                        }else{
                                          return "〇";
                                        }
                                    })()}
                                  </td>
                                  <td scope="col" className="text-center">{ patient.birthday ? patient.japanese_calendar_birthday + '（' + calcAge(patient.birthday.replace(/-/g , '')) + '）' : ''}</td>
                                  <td scope="col" className="text-center">{ patient.mobile_phone }</td>
                                </tr>
                              </>
                            )
                          })
                        }
                        </tbody>
                      </table>
                    </div> {/* /patient-table-wrapper */}
                  </div> {/* /text-center */}
                </form>
                <div className="btn btn-primary" onClick={() => link(props.dInterviewDetailId, selectedMPatient)}>紐づける</div>
              </div> {/* /modal-body */}
            </div> {/* /modal-content */}
          </div> {/* /modal-dialog */}
        </div> {/* /modal */}
      </>
    );
};

export default Modal;